import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';
import { FileTypes } from 'src/views/archive/types';

export type IArchiveFilterState = {
    createdAtFrom: string;
    createdAtTo: string;
    fileType?: FileTypes;
};

type ArchiveAction = {
    createdAtFrom?: string;
    createdAtTo?: string;
    fileType?: FileTypes;
};

export const initialState: IArchiveFilterState = {
    createdAtFrom: moment().startOf('year').format('YYYY-MM-DD'),
    createdAtTo: moment().format('YYYY-MM-DD'),
    fileType: '' as FileTypes,
};

const slice = createSlice({
    name: 'archiveFilters',
    initialState,
    reducers: {
        setCreatedAtFrom(
            state: IArchiveFilterState,
            action: PayloadAction<ArchiveAction>
        ) {
            state.createdAtFrom = action.payload.createdAtFrom;
        },
        setCreatedAtTo(
            state: IArchiveFilterState,
            action: PayloadAction<ArchiveAction>
        ) {
            state.createdAtTo = action.payload.createdAtTo;
        },
        setFileType(
            state: IArchiveFilterState,
            action: PayloadAction<ArchiveAction>
        ) {
            state.fileType = action.payload.fileType;
        },
        resetFilters(
            state: IArchiveFilterState
        ) {
            state.createdAtFrom = initialState.createdAtFrom;
            state.createdAtTo = initialState.createdAtTo;
            state.fileType = initialState.fileType;
        },
    }
});

export const { reducer } = slice;

export const {
    setCreatedAtFrom,
    setCreatedAtTo,
    setFileType,
    resetFilters,
  } = slice.actions;

export default slice;
